<!-- deprecated -->

<script lang="ts" setup>
    import { reactive, onMounted } from 'vue';
    import { currentChoiceUser } from '../../lib/ChoiceUtils';
    import { ClinicianModel } from '../../lib/Models/FHIR/ClinicianModel';
    import { FhirApiModel } from '../../lib/Models/FHIR/FhirApiModel';
    import { LoadingSection } from '../../LibMain';
    import * as ChoiceApi from '../../lib/ChoiceApi';
    import * as Notification from '../../lib/Notification'
    import { SimpleUserInfoModel } from '../../lib/Models/User/SimpleUserInfoModel';

    interface Launching { launching?: boolean};
    type ClientFhirInfo = FhirApiModel & Launching;

    const formData = reactive<{
        apiClients: ClientFhirInfo[],
        clinicians?: ClinicianModel[],
        selectedClinician?: ClinicianModel,
        currentAppUser?: SimpleUserInfoModel
    }>({
        apiClients: [],
        clinicians: []
    });

    onMounted(async () => {
        const currentUserId = currentChoiceUser();
        if (!currentUserId)
        {
            alert("Current user ID not available");
            return;
        }

        formData.apiClients = await ChoiceApi.FHIR.getApiClients();
        formData.clinicians = await ChoiceApi.FHIR.getClinicians();
        formData.currentAppUser = (await ChoiceApi.user.SimpleInfo(currentUserId));

        // Set the selected clinician
        formData.selectedClinician = formData.clinicians.find(item => item.entityId == formData.currentAppUser?.entity_id);
    });

    async function launchApi(apiClientInfo: ClientFhirInfo)
    {
        if (!formData.selectedClinician?.nationalProviderId)
        {
            await Notification.popAlert("Unable to determine NPI");
            return;
        }

        apiClientInfo.launching = true;
        const apiLaunchUrl = await ChoiceApi.FHIR.ehrLaunchUrl(apiClientInfo.description, formData.selectedClinician?.nationalProviderId);
        apiClientInfo.launching = false;
        if (!apiLaunchUrl)
        {
            await Notification.popAlert("Unable to get API launch data");
            return;
        }

        window.open(apiLaunchUrl, '_blank');
    }

    function isCurrentUser(clinician: ClinicianModel): boolean
    {
        return clinician.entityId === formData.currentAppUser?.entity_id;
    }
</script>

<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-2 col-sm-3">Clinician</div>
            <div class="col-md-10 col-sm-9">
                <select v-model="formData.selectedClinician" class="form-select">
                    <option v-for="clinician in formData.clinicians" :value="clinician">
                        {{clinician.name}} ({{clinician.nationalProviderId}})
                        <span v-if="isCurrentUser(clinician)" class="text-success">[{{formData.currentAppUser?.users_id}}]</span>
                    </option>
                </select>
            </div>
        </div>
        <br/>

        <div v-if="formData.selectedClinician">
            <div class="row">
                <div class="col-md-2 col-sm-3"><strong>Action</strong></div>
                <div class="col-md-10 col-sm-9"><strong>SMART on FHIR API Name</strong></div>
            </div>
    
            <div class="row pb-1" v-for="apiClient in formData.apiClients">
                <div class="col-md-2 col-sm-3">
                    <LoadingSection loadingMsg="Launching..." :isLoading="apiClient.launching ?? false">
                        <button @click="launchApi(apiClient)"
                            class="btn btn-primary" 
                            title="Launch FHIR API"
                            target="_blank">
                            <em class="fa-solid fa-rocket"></em>
                            Launch
                        </button>
                    </LoadingSection>
                </div>
                <div class="col-md-10 col-sm-9">
                    {{apiClient.description}}
                </div>
            </div>
        </div>
        <div v-if="!formData.selectedClinician" class="alert alert-warning">
            Please select a clinician: the current user does not have an assocaited NPI.
        </div>

    </div>

</template>